import React from 'react';
import { motion } from 'framer-motion';

const InfiniteLogoCrawler = ({ data = {} }) => {
  const logos = data.logos || [
    '🏢', '🚀', '💼', '🎯', '⚡', '🌟', '💡', '🔥'
  ];
  const speed = data.speed || 20;
  const direction = data.direction || 'left';

  // Duplicate logos for seamless loop
  const duplicatedLogos = [...logos, ...logos];

  return (
    <div className="flex items-center justify-center h-full bg-gray-50 overflow-hidden">
      <div className="w-full">
        <div className="text-center mb-8">
          <h3 className="text-2xl font-bold text-gray-800">
            {data.title || 'Trusted by leading brands'}
          </h3>
        </div>
        
        <div className="relative overflow-hidden">
          <motion.div
            className="flex gap-12 items-center"
            animate={{
              x: direction === 'left' ? ['0%', '-50%'] : ['-50%', '0%'],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: 'loop',
                duration: speed,
                ease: 'linear',
              },
            }}
          >
            {duplicatedLogos.map((logo, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-24 h-24 bg-white rounded-lg shadow-md flex items-center justify-center text-4xl hover:shadow-xl transition-shadow"
              >
                {typeof logo === 'string' && (logo.startsWith('http') || logo.startsWith('data:')) ? (
                  <img 
                    src={logo} 
                    alt={`Logo ${index}`} 
                    className="w-16 h-16 object-contain"
                  />
                ) : (
                  <span>{logo}</span>
                )}
              </div>
            ))}
          </motion.div>
        </div>

        {/* Second row moving opposite direction */}
        <div className="relative overflow-hidden mt-8">
          <motion.div
            className="flex gap-12 items-center"
            animate={{
              x: direction === 'left' ? ['-50%', '0%'] : ['0%', '-50%'],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: 'loop',
                duration: speed,
                ease: 'linear',
              },
            }}
          >
            {duplicatedLogos.map((logo, index) => (
              <div
                key={index}
                className="flex-shrink-0 w-24 h-24 bg-white rounded-lg shadow-md flex items-center justify-center text-4xl hover:shadow-xl transition-shadow"
              >
                {typeof logo === 'string' && (logo.startsWith('http') || logo.startsWith('data:')) ? (
                  <img 
                    src={logo} 
                    alt={`Logo ${index}`} 
                    className="w-16 h-16 object-contain"
                  />
                ) : (
                  <span>{logo}</span>
                )}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default InfiniteLogoCrawler;

